import React from 'react';

import {DetailPageGenericPoliciesSidebar} from 'app/components/general/DetailPageGenericPoliciesSidebar';
import {
  convertLocationParamsToFetchParams,
  useAttachPolicyToProcess,
  useDetachPolicyFromProcess,
  usePolicies,
} from 'app/policies/api';

import type {
  NestedPolicyProcessSerializedType,
  ProcessHashidSerializedType,
} from 'sweet-types';

type Props = {
  process: ProcessHashidSerializedType;
  items: Array<NestedPolicyProcessSerializedType>;
};
export const ProcessPoliciesSidebar = ({process, items}: Props) => {
  const [attachPolicyToProcess] = useAttachPolicyToProcess();
  const [detachPolicyFromProcess] = useDetachPolicyFromProcess();

  return (
    <DetailPageGenericPoliciesSidebar
      attachedItems={items}
      closeUrl={process.html_url}
      detailPageObjectId={process.id}
      detailPageContentType={'proceduregroup'}
      sidebarContentType={'policy'}
      showFilterField={process.can_edit}
      canEdit={process.can_edit}
      useDataHook={usePolicies}
      onAttach={(item) => {
        return attachPolicyToProcess({
          genericLinks: [
            {
              policy: item.url,
              process: process.url,
            },
          ],
        });
      }}
      onRemove={(item) => {
        const linkedDocument = items.find(
          (attachedItem) => attachedItem.url === item.url
        );
        if (linkedDocument != null) {
          return detachPolicyFromProcess(linkedDocument.link_url);
        }
        throw 'Linked document not found';
      }}
      paramsConverter={convertLocationParamsToFetchParams}
    />
  );
};
